import { FC } from "react";
import KatakomButton from "../shared/KatakomButton";
import styled from "styled-components";
import { themeColors, themeIcon } from "../../constants/constants";
import { Row } from "../pages/style";

interface Props {
    closeModal: () => void;
    message: string;
}

export const SuccessMessageModal: FC<Props> = ({ message, closeModal }) => {
    return (
        <ModalContainer>
            <ModalIcon />
            <ModalTitle>{message}</ModalTitle>
            <Row style={{ justifyContent: "center" }}>
                <KatakomButton
                    label={"Изађи"}
                    onClick={() => {
                        closeModal();
                    }}
                    style={{ margin: "0 30px 0 0 ", textAlign: "center" }}
                />
            </Row>
        </ModalContainer>
    );
};

const ModalContainer = styled.div`
    width: 500px;
    height: 400px;
    background-color: ${themeColors.primary};
    display: flex;
    flex-direction: column;
    text-align: center;
    position: absolute;
    top: 20%;
    overflow: hidden;
    margin-left: -200px;

    &:before {
        content: "";
        position: absolute;
        top: -105px;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: url(${themeIcon}/checkMarkBackground.png);
        background-repeat: no-repeat;
        background-position: right center;
        background-size: contain;
        opacity: 1;
    }

    @media screen and (max-width: 900px) {
        margin-left: -500px;
    }
`;

const ModalIcon = styled.div`
    width: 100px;
    height: 100px;
    margin: 30px auto;
    background-image: url(${themeIcon}/check.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    z-index: 1;
`;

const ModalTitle = styled.div`
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 40px;
    z-index: 1;
`;
